import service from '../../../services/stock/account';
import { arrayPushOrUpdateByID } from './../../../utils/toolkit';
export default {
    namespaced: true,
    state: {
        data: [],
        loading: false
    },
    getters: {
        data: (state) => state.data,
        loading: (state) => state.loading,
    },
    mutations: {
        push: (state, payload) => state.data = arrayPushOrUpdateByID(state.data, payload),
        setLoading: (state, payload) => state.loading = payload,
    },
    actions: {
        get(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                service.search(payload) 
                    .then(response => {
                        context.commit("push", response.data);
                        resolve(response)
                    })
                    .catch(error => reject(error))
                    .finally(() => {
                    context.commit("setLoading", false)
                })
            })
        },
        push(context, payload) {
            context.commit("push", [payload]);
        }
    }
}